// extracted by mini-css-extract-plugin
module.exports = {"container":"DynamicPlaceholder_container__PGoX9","lockIcon":"DynamicPlaceholder_lockIcon__OuuKn"};